import tagsData from '@shared/tags.json';

export interface ThesisPoint {
    id: string;
    category: string;
    title: string;
    description: string;
    type?: 'green' | 'red';
}

export const THESIS_CATEGORIES = [
    "Team & Founders",
    "Market & Economics",
    "AI & Technology",
    "Product & Traction",
    "Strategy & Philosophy",
] as const;

// Green flags (strengths) - the original thesis points
export const GREEN_FLAGS: ThesisPoint[] = tagsData.green_flags.map(tag => ({
    ...tag,
    type: 'green' as const,
}));

// Red flags (risks)
export const RED_FLAGS: ThesisPoint[] = tagsData.red_flags.map(tag => ({
    ...tag,
    type: 'red' as const,
}));

// Backward compatibility: MASTER_THESIS_POINTS = green flags
export const MASTER_THESIS_POINTS: ThesisPoint[] = GREEN_FLAGS;
